export interface IEditSampleMeasurement {
    sampleId?:string;
    measurementId?:string;
    propertyDetail?:IPropertyDetail[];
 }

 interface IPositionValues {
    oldValue: number;
    newValue: number;
    count: number;
    valueRangeStatusId: string;
    valueRangeStatus: string;
 }

 interface IPositionDetails {
    positionName:string;
    position: number;
    mean: number;
    positionValues: IPositionValues[];
 }

export interface IPropertyDetail {
    id:string;
    name:string;
    directionId:string;
    positionDetails:IPositionDetails[];
}

export const InitiaDataReq = {
    id: "",
    name: "",
    directionId: "",
    positionDetails: [{
      positionName: "",
      position: 0,
      mean: 0,
      positionValues: [{
        oldValue: 0,
        newValue: 0,
        count: 0,
        valueRangeStatusId: "",
        valueRangeStatus: ""
      }]
    }]
}